// Alternate fix if loading="lazy" does not work

function lazyload() {
 const lazyLoadImages = document.querySelectorAll(".lazy");

const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            const lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove("lazy");
            imageObserver.unobserve(lazyImage);
          }
        });
      });

    lazyLoadImages.forEach((lazyImage) => {
        // Check if the image is already in the viewport (top of page)
        const rect = lazyImage.getBoundingClientRect();
        const inView = rect.top < window.innerHeight && rect.bottom > 0;

        if (inView) {
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove("lazy");
        } else {
            imageObserver.observe(lazyImage);
        }
    });
}

document.addEventListener("DOMContentLoaded", lazyload);
